import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import fileUpload from "ng-file-upload";
import accessControlCrud from "../access-control-crud/access-control-crud.module";
import usersControl from "../users-control/users-control.module";
import invitesControl from "../invites-control/invites-control.module";
import registerRequestsControl from "../register-requests-control/register-requests-control.module"
import organizationsControl from "../organizations-control/organizations-control.module";
import registerForm from "../register-form/register-form.module";
import lessonsModal from "../lessons-modal/lessons-modal.module";
import stationsControl from "../stations-control/stations-control.module";
import articlesControl from "../articles-control/articles-control.module";
import paramsControl from "../params-control/params-control.module";
import citizenshipsControl from "../citizenships-control/citizenships-control.module";
import trainsControl from "../trains-control/trains-control.module";
import mobiusControl from "../mobius-control/mobius-control.module";
import bookingModule from "../booking-module/booking-module.module";
import clearClass from "./clearClass";
import orders from "../orders/orders.module";
import activeOperations from "../active-operations/active-operations.module";
import directionsControl from "../directions-control/directions-control.module";
import directionOptionsControl from "../direction-options-control/direction-options-control.module";
import dailyReport from "../daily-report/daily-report.module";
import dashboard from "../dashboard/dashboard.module";
import customFilters from "./customFilters";
import sockedIdRequest from "./socketIdRequest";
import XMLHttpRequest from "./XMLHttpRequest";
import importantNotice from "../important-notice/important-notice";
import errorProcessing from "../error-processing/error-processing.module";
import scheduleGenerate from "../schedule-generate/schedule-generate.module";

angular.module('app', [
    angularUIB,
    accessControlCrud,
    usersControl,
    invitesControl,
    registerRequestsControl,
    organizationsControl,
    registerForm,
    lessonsModal,
    stationsControl,
    articlesControl,
    paramsControl,
    citizenshipsControl,
    mobiusControl,
    bookingModule,
    clearClass,
    orders,
    trainsControl,
    activeOperations,
    importantNotice,
    directionsControl,
    dailyReport,
    dashboard,
    customFilters,
    sockedIdRequest,
    XMLHttpRequest,
    errorProcessing,
    directionOptionsControl,
    fileUpload,
    scheduleGenerate
]);

angular
    .module('app')
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('sockedIdRequest');
        $httpProvider.interceptors.push('XMLHttpRequest');
    }])
    .controller('MainController', ['$rootScope', '$scope', '$uibModal', function ($rootScope, $scope, $uibModal) {

        if (window.userChannel) {
            window
                .userChannel
                .listen('.order.changed', function (e) {
                    $rootScope.$emit('order.changed', e);
                })
                .listen('.transaction.executed', function (e) {
                    $rootScope.$emit('transaction.executed', e);
                });
        }

        if (window.publicChannel) {
            window
                .publicChannel
                .listen('.article.published', function (e) {
                    $rootScope.$emit('article.published', e);
                });
        }

        $rootScope.$on('article.published', function (event, data) {
            let article = data.article;
            if (article.is_important) {
                $uibModal.open({
                    component: 'importantNotice',
                    resolve: {
                        article: function () {
                            return article;
                        }
                    },
                    backdrop: false
                });
            }
        });

    }])
    .controller('LoginPageController', ['$scope', function ($scope) {
        $scope.showPassword = false;
        $scope.toggleShowPassword = function () {
            $scope.showPassword = !$scope.showPassword;
        };
    }])
    .controller('ResetPassPageController', ['$scope', function ($scope) {
        $scope.showPassword = false;
        $scope.showPasswordConfirm = false;
        $scope.toggleShowPassword = function () {
            $scope.showPassword = !$scope.showPassword;
        };
        $scope.toggleShowConfimPass = function () {
            $scope.showPasswordConfirm = !$scope.showPasswordConfirm;
        };
    }])
    .controller('ArticleViewController', ['$scope', '$http', '$timeout', '$rootScope', function ($scope, $http, $timeout, $rootScope) {

        $scope.data = {
            articleId: null,
        };

        $scope.initArticle = function (id) {
            $scope.data.articleId = id;
            $timeout(function () {
                $http
                    .post('/press/' + id + '/opened')
                    .then(function () {
                        $rootScope.$emit('article.opened', {articleId: id});
                    });
            }, 1500);
        };

    }]);

require('../components/clients-control/clients-control');
require('../components/client-form/client-form');
require('../components/clients-import-form/clients-import-form');
require('../components/client-import-error-messages/client-import-error-messages');

// require('../components/employees-control/employees-control');
require('../components/client-employees-control/client-employees-control');
require('../components/client-employees-import-form/client-employees-import-form');

require('../components/employee-import-info/employee-import-info');
require('../components/employee-form/employee-form');

require('../components/fields-control/fields-control');
require('../components/field-form/field-form');

require('../components/organization-clients-control/organization-clients-control');
require('../components/clients-fields-control/clients-fields-control');
// require('../components/client-field-item-form/client-field-item-form');
require('../components/organization-client-form/organization-client-form');
require('../components/organization-clients-import-form/organization-clients-import-form');
require('../components/organization-client-employees-import-form/organization-client-employees-import-form');
require('../components/organization-client-employees/organization-client-employees');
require('../components/employees-fields-control/employees-fields-control');

require('../components/attach-field-form/attach-field-form');
require('../components/attach-field-to-clients/attach-field-to-clients');
require('../components/attach-field-to-client/attach-field-to-client');
require('../components/import-employees/import-employees');

require('../components/customer-control/customer-control');
require('../components/organization-info/organization-info');
require('../components/organization-invite-form/organization-invite-form');

require('../components/customer-users-control/customer-users-control');
require('../components/customer-user-form/customer-user-form');

// require('../components/organization-client-fields-form/organization-client-fields-form');
// require('../components/organization-client-field-form/organization-client-field-form');

export default 'app';



// WEBPACK FOOTER //
// ./resources/assets/modules/app/app.module.js